import { makeVar } from '@apollo/client';
import { GraphUser } from '../../graphql/types';
import { DeepPartial, IUser } from '../types';
export const isMenuShow = makeVar<boolean>(false);
export const isUpgradeShow = makeVar<boolean>(false);
export const isPublishShow = makeVar({isActive: false, pageId: null, sharePage: false});
export const isShowTemplateModal = makeVar({isActive: false, page: null});
export const moveItem = makeVar({isActive: false, data: {folderIds: [], pageIds: []}});
export const renameFolder = makeVar({isActive: false, folderId: null})
export const selectedCurrency = makeVar("usd");
export const isUrlUniqueError = makeVar<boolean>(false);
export const isPaymentError = makeVar<boolean>(false);
export const isPaymentLoading = makeVar<boolean>(false);
export const isLoadingOfDeletion = makeVar<boolean>(false);
export const isShowNewProjectModal = makeVar<boolean>(false);
export const isSavedChanges = makeVar<boolean>(false);
export const isHaveBeenSaved = makeVar<boolean>(false)
export const isHaveBeenBlocked = makeVar<boolean>(false)
export const duplicatePageModal = makeVar<number | null>(null)
export const projectLimitModal = makeVar<boolean>(false)
export const publishLimitModal = makeVar<boolean>(false)
export const editPremium = makeVar<{isActive: boolean, user: DeepPartial<GraphUser> | null}>({isActive: false, user: null})
export const currentUser = makeVar<IUser>(null)
export const isUserLoading = makeVar<boolean>(true)

